export default "__VITE_ASSET__98c20014__"